import React from 'react';

interface HeaderSectionProps {
  label: string;
  width: number;
  height?: number;
  backgroundColor?: string;
  borderColor?: string;
  index?: number;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({
  label,
  width,
  height = 36,
  backgroundColor,
  borderColor,
  index = 0
}) => {
  const isEvenIndex = index % 2 === 0;
  const classNames = `flex items-center justify-center relative border-b border-r ${
    isEvenIndex 
      ? 'bg-gray-50 dark:bg-[#111928]' 
      : 'bg-gray-100 dark:bg-[#151D2E]'
  } text-gray-700 dark:text-white border-gray-200 dark:border-[#374151] border-r-gray-200 dark:border-r-[#374151]`;
  
  return (
    <div
      className={classNames}
      style={{
        width,
        minWidth: width,
        height: `${height}px`,
        ...(backgroundColor && { backgroundColor }),
        ...(borderColor && { borderRightColor: borderColor }),
        zIndex:40
      }}
    >
      <span className="text-sm font-medium">{label}</span>
    </div>
  );
}; 